module.exports = __webpack_public_path__ + "img/2.b14e42b5.png";